//
//  moods-page-style.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue, Component, Prop } from 'vue-property-decorator';
import { LocaleMessage } from 'vue-i18n';

@Component
export default class MoodsPageStyle extends Vue {

    @Prop(String) private readonly title!: LocaleMessage;
    @Prop(String) private readonly leftText!: LocaleMessage;
    @Prop(String) private readonly rightText!: LocaleMessage;

}
